import { Text } from '../../Form/Inputs/Text.js';
import { Hidden } from '../../Form/Inputs/Hidden.js';

export const Outlinks = (props) => {
    const { el } = props;
    return (
        <>
            <Text name="name" value={el ? el.name : ''} />
            <Text name="link" value={el ? el.route : ''} />
            <Hidden name="id" value={el ? el.id : ''} />
        </>
    )
}